import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import './About.css';
import aboutEmblem from '../assets/amblemfs.png';

const About = () => {
  return (
    <>
      <Helmet>
        <title>Hakkımızda - FlowSky CRM</title>
        <meta 
          name="description" 
          content="FlowSky CRM hakkında bilgi edinin. Uçtan uca müşteri ilişkileri yönetimi, raporlama ve otomasyon ile işletmenizi güçlendirin." 
        />
      </Helmet>
      
      <section className="about-page section">
        <div className="container">
          <motion.div
            className="about-hero"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="about-emblem" aria-hidden="true">
              <img
                className="about-emblem-img"
                src={aboutEmblem}
                alt="FlowSky CRM amblemi"
                loading="lazy"
              />
            </div>
            <div className="about-intro">
              <p>
                FlowSky CRM, işletmelerin müşteri ilişkilerini uçtan uca profesyonelce yönetebilmeleri için geliştirilmiş,
                esnek ve ölçeklenebilir bir müşteri ilişkileri yönetim platformudur. Satış, pazarlama ve operasyon
                süreçlerini tek bir merkezde toplayarak ekipler arası koordinasyonu güçlendirir ve iş süreçlerini daha
                verimli hale getirir. Modern teknolojilerle geliştirilen altyapısı ve kullanıcı odaklı arayüz tasarımı
                sayesinde, FlowSky CRM öğrenmesi kolay, kullanımı hızlı ve her ölçekte işletmeye uyum sağlayan bir deneyim
                sunar. Gerçek zamanlı veri takibi, detaylı raporlama ve akıllı otomasyon özellikleri ile karar alma
                süreçlerinizi desteklerken, müşteri memnuniyetini artırmanıza yardımcı olur. FlowSky CRM ile yalnızca
                müşteri bilgilerinizi yönetmekle kalmaz, aynı zamanda sürdürülebilir büyüme hedeflerinize ulaşmanızı
                sağlayacak güçlü ve güvenilir bir dijital çözüm elde edersiniz.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default About;

